// Serious Business Sticky Cards Animation (ES Module)

document.addEventListener("DOMContentLoaded", () => {
     gsap.registerPlugin(ScrollTrigger);
     const lenis = new Lenis();
     lenis.on("scroll", ScrollTrigger.update);
     gsap.ticker.add((time) => {
          lenis.raf(time * 1000);
     });
     gsap.ticker.lagSmoothing(0);

     const cards = gsap.utils.toArray(".serious-business-card");

     ScrollTrigger.create({
          trigger: cards[0],
          start: "top 35%",
          endTrigger: cards[cards.length - 1],
          end: "top 30%",
          pin: ".serious-business-intro",
          pinSpacing: false,
     });

     // Detect if we're on mobile/tablet (similar to CSS breakpoint)
     // On mobile/tablet (< 1000px): animate ALL cards including the last one
     // On desktop (≥ 1000px): exclude last card AND 4th card from animation
     const isMobileOrTablet = window.innerWidth < 1000;

     cards.forEach((card, index) => {
          const isLastCard = index === cards.length - 1;
          const isFourthCard = index === 3; // 4th card (0-based index 3)
          const cardInner = card.querySelector(".serious-business-card-inner");

          // On mobile/tablet, animate all cards including the last one
          // On desktop, exclude the last card AND the 4th card from animation
          const shouldAnimateCard = isMobileOrTablet ? true : !(isLastCard || isFourthCard);

          if (shouldAnimateCard) {
               ScrollTrigger.create({
                    trigger: card,
                    start: "top 35%",
                    endTrigger: ".serious-business-outro",
                    end: "top 65%",
                    pin: true,
                    pinSpacing: false,
               });

               gsap.to(cardInner, {
                    y: `-${(cards.length - index) * 14}vh`,
                    ease: "none",
                    scrollTrigger: {
                         trigger: card,
                         start: "top 35%",
                         endTrigger: ".serious-business-outro",
                         end: "top 65%",
                         scrub: true,
                    },
               });
          }
     });

     // Function to reorganize card layout for mobile
     function reorganizeCardLayout() {
          const isMobile = window.innerWidth < 1000;
          const cards = document.querySelectorAll('.serious-business-card');

          cards.forEach(card => {
               const contentDiv = card.querySelector('.serious-business-card-content');
               const imgDiv = card.querySelector('.serious-business-card-img');

               if (isMobile) {
                    // On mobile: move image inside content div if not already there
                    if (!contentDiv.contains(imgDiv)) {
                         contentDiv.appendChild(imgDiv);
                    }
               } else {
                    // On desktop: move image back outside content div if not already there
                    const cardInner = card.querySelector('.serious-business-card-inner');
                    if (cardInner && !cardInner.contains(imgDiv)) {
                         cardInner.appendChild(imgDiv);
                    }
               }
          });
     }

     // Initial layout organization
     reorganizeCardLayout();

     // Handle window resize to update animation behavior and layout
     window.addEventListener('resize', () => {
          // Reorganize layout based on screen size
          reorganizeCardLayout();
          // Refresh ScrollTrigger instances on resize
          ScrollTrigger.refresh();
     });
});
